import { Table } from '@/components/asset/table'

export const Index = () => {
  return (
    <>
      <div className="flex flex-col gap-12">
        <Table pageSize={20} createable onIndex />
      </div>
    </>
  )
}
